export default function (str) {
  return str ? (str+'').replace(/<\/?[^>]+>/ig, " ") : ''
}
